/* eslint-disable-next-line import/named */
import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { AUTO_WIDTH_BREAKPOINT } from "../Button/Button.styles.mjs.mjs";
const getButtonSpacing = (props) => {
    switch (props.variant) {
        case 'block-buttons':
            return `
        @media (max-width: ${props.theme.breakpoints.m - 1}px) {
          gap: var(${props.theme.responsive.spacing.xxs});
          row-gap: var(${props.theme.responsive.spacing.xs});
        }
        gap: var(${props.theme.responsive.spacing.xxs});`;
        case 'text-buttons':
            return `gap: var(${props.theme.responsive.spacing.l})`;
    }
};
export const StyledContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-1uhplj2" }) `
  ${injectSpacing('margin')}
`;
export const StyledButtonGroup = styled.div.withConfig({ displayName: "auir-611444a-StyledButtonGroup", componentId: "auir-611444a-u0ov2l" }) `
  display: flex;
  flex-flow: row wrap;
  ${getButtonSpacing};
  align-items: center;

  @media (min-width: ${AUTO_WIDTH_BREAKPOINT}) {
    display: ${(props) => (props.block ? 'flex' : 'inline-flex')};
  }
`;
//# sourceMappingURL=ButtonGroup.styles.mjs.mjs.map